/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { InstitutionApprenantLiesGridDto } from './InstitutionApprenantLiesGridDto';
import {
    InstitutionApprenantLiesGridDtoFromJSON,
    InstitutionApprenantLiesGridDtoFromJSONTyped,
    InstitutionApprenantLiesGridDtoToJSON,
} from './InstitutionApprenantLiesGridDto';

/**
 * 
 * @export
 * @interface InstitutionApprenantLiesGridDtoPaginatedResults
 */
export interface InstitutionApprenantLiesGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof InstitutionApprenantLiesGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<InstitutionApprenantLiesGridDto>}
     * @memberof InstitutionApprenantLiesGridDtoPaginatedResults
     */
    results?: Array<InstitutionApprenantLiesGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof InstitutionApprenantLiesGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the InstitutionApprenantLiesGridDtoPaginatedResults interface.
 */
export function instanceOfInstitutionApprenantLiesGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InstitutionApprenantLiesGridDtoPaginatedResultsFromJSON(json: any): InstitutionApprenantLiesGridDtoPaginatedResults {
    return InstitutionApprenantLiesGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function InstitutionApprenantLiesGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstitutionApprenantLiesGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(InstitutionApprenantLiesGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function InstitutionApprenantLiesGridDtoPaginatedResultsToJSON(value?: InstitutionApprenantLiesGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(InstitutionApprenantLiesGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

